var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import * as d3 from 'd3';
import PropTypes from 'prop-types';
import { createYScale } from '../../utils/scale-helpers';
import GriffPropTypes from '../../utils/proptypes';
import AxisPlacement from '../AxisPlacement';

var CollapsedAxis = (_temp2 = _class = function (_Component) {
  _inherits(CollapsedAxis, _Component);

  function CollapsedAxis() {
    var _temp, _this, _ret;

    _classCallCheck(this, CollapsedAxis);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getPath = function (_ref) {
      var offsetx = _ref.offsetx,
          strokeWidth = _ref.strokeWidth,
          tickSizeOuter = _ref.tickSizeOuter,
          range = _ref.range;
      var _this$props = _this.props,
          yAxisPlacement = _this$props.yAxisPlacement,
          width = _this$props.width;

      switch (yAxisPlacement) {
        case AxisPlacement.LEFT:
          return [
          // Move to this (x,y); start drawing
          'M ' + (width - offsetx) + ' ' + strokeWidth,
          // Draw a horizontal line to the left
          'h ' + (tickSizeOuter - strokeWidth),
          // Draw a vertical line from top to bottom
          'v ' + (range[0] - strokeWidth * 2),
          // Finish with another horizontal line
          'h -' + (tickSizeOuter - strokeWidth / 2)].join(' ');
        case AxisPlacement.BOTH:
          throw new Error('BOTH is not a valid option for CollapsedAxis -- please specify RIGHT or LEFT');
        case AxisPlacement.RIGHT:
        case AxisPlacement.UNSPECIFIED:
        default:
          return [
          // Move to this (x,y); start drawing
          'M ' + offsetx + ' ' + strokeWidth,
          // Draw a horizontal line to the left
          'h -' + (tickSizeOuter - strokeWidth),
          // Draw a vertical line from top to bottom
          'v ' + (range[0] - strokeWidth * 2),
          // Finish with another horizontal line
          'h ' + (tickSizeOuter - strokeWidth / 2)].join(' ');
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CollapsedAxis.prototype.renderAxis = function renderAxis() {
    var _props = this.props,
        color = _props.color,
        height = _props.height,
        onMouseEnter = _props.onMouseEnter,
        onMouseLeave = _props.onMouseLeave;

    var scale = createYScale([0, 100], height);
    var axis = d3.axisRight(scale);
    var tickFontSize = 14;
    var strokeWidth = 2;
    var tickSizeOuter = axis.tickSizeOuter();
    var range = scale.range();
    var paths = {};
    var offsetx = 0;
    for (var i = 1; i < 4; i += 1) {
      offsetx += tickSizeOuter;
      paths[i] = {
        path: this.getPath({ offsetx: offsetx, strokeWidth: strokeWidth, tickSizeOuter: tickSizeOuter, range: range }),
        color: color,
        opacity: 1 - (i - 1) / 4
      };

      offsetx += 3;
    }
    return React.createElement(
      'g',
      {
        className: 'axis',
        fill: 'none',
        fontSize: tickFontSize,
        textAnchor: 'start',
        strokeWidth: strokeWidth,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
      },
      Object.keys(paths).map(function (key) {
        return React.createElement('path', {
          key: key,
          stroke: paths[key].color,
          opacity: paths[key].opacity || 1,
          d: paths[key].path
        });
      })
    );
  };

  CollapsedAxis.prototype.render = function render() {
    var offsetx = this.props.offsetx;

    return React.createElement(
      'g',
      {
        className: 'axis-y collapsed-axis-y',
        transform: 'translate(' + offsetx + ', 0)'
      },
      this.renderAxis()
    );
  };

  return CollapsedAxis;
}(Component), _class.defaultProps = {
  color: '#666',
  offsetx: 0,
  onMouseEnter: null,
  onMouseLeave: null,
  yAxisPlacement: AxisPlacement.RIGHT
}, _temp2);
export { CollapsedAxis as default };
CollapsedAxis.propTypes = process.env.NODE_ENV !== "production" ? {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  offsetx: PropTypes.number,
  color: PropTypes.string,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  yAxisPlacement: GriffPropTypes.axisPlacement
} : {};